module.exports = "<footer>\r\n\t <div class=\"container\" [innerHtml]=\"htmlString\"></div>\r\n</footer>"